import React, { useState } from "react";
import AddNCAssesment from "../../admin/survey/AddNCAssesment";
import ListNCAssesment from "../../admin/survey/ListNCAssesment";

function NcAssesment() {
  
  
  const [activeTab, setActiveTab] = useState("NcAssesment"); // Default tab

  const dummyData = [
    {
      surveyName: "Cognitive Assessment",
      audience: "John Smith",
      campus: "Main Campus",
      cls: "Grade 5",
      section: "A",
      surveyReport: "Completed"
    },
    {
      surveyName: "Memory Test",
      audience: "Sarah Johnson",
      campus: "North Campus",
      cls: "Grade 3",
      section: "B",
      surveyReport: "Pending"
    },
    {
      surveyName: "Attention Assessment",
      audience: "Tom Brown",
      campus: "South Campus",
      cls: "Grade 4",
      section: "C",
      surveyReport: "In Progress"
    }
  ];

  return (
    <div>
      <div className="flex space-x-4 border-b mb-4">
        <button
          onClick={() => setActiveTab("NcAssesment")}
          className={`px-4 py-2 ${
            activeTab === "NcAssesment" ? "text-[#241763] border-b-2 border-[#241763]" : "text-gray-500"
          }`}
        >
          NCAssessment
        </button>
        <button
          onClick={() => setActiveTab("ListNcAssesment")}
          className={`px-4 py-2 ${
            activeTab === "ListNcAssesment" ? "text-[#241763] border-b-2 border-[#241763]" : "text-gray-500"
          }`}
        >
          NCAssessment Responce
        </button>
      </div>
      {activeTab === "NcAssesment" && (
        <AddNCAssesment/>
      )}

      {/* List NC Assessment Tab Content */}
      {activeTab === "ListNcAssesment" && (
        <ListNCAssesment/>
      )}

      
    </div>
  );
}

export default NcAssesment;